import { CardActionArea, SxProps, Typography, useTheme } from '@mui/material'
import { FlexBox } from 'components/atoms'
import { useBetContext } from 'contexts/BetContext'

export const SymbolButton = ({
    symbol,
    onClick,
    label,
    sx = {}
}: {
    symbol: string
    onClick: () => void
    label?: string
    sx?: SxProps
}) => {
    const theme = useTheme()
    const { mainColor } = useBetContext()

    return (
        <CardActionArea
            sx={{ width: 'fit-content' }}
            onClick={() => onClick && onClick()}
        >
            <FlexBox
                sx={{
                    height: 31,
                    minWidth: 31,
                    border: `1px solid ${mainColor}`,
                    borderRadius: theme.spacing(0.5),
                    justifyContent: 'center',
                    px: label ? 1 : 0,
                    ...sx
                }}
            >
                {label && (
                    <Typography
                        variant="title-14-bold"
                        sx={{
                            pr: 1,
                            color: mainColor
                        }}
                    >
                        {label}
                    </Typography>
                )}
                <Typography
                    variant="title-16-bold"
                    sx={{
                        fontSize: 20,
                        color: mainColor
                    }}
                >
                    {symbol}
                </Typography>
            </FlexBox>
        </CardActionArea>
    )
}
